import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {Info, Warning} from "@mui/icons-material";
import React from "react";
import {resetCredentials} from "../management/companies/configs/functions";
import {useCommonItems} from "../../../contexts/CommonItensProvider";


export function ResetCredentials({
                                     open,
                                     setOpen,
                                     reloadPessoa,
                                     selectedPessoa
                                 }) {
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();

    async function handleResetCredentials() {
        try {
            exibirDialog('Resetando credenciais...');

            const res = await resetCredentials(selectedPessoa.empresa.id, selectedPessoa.matricula);

            if (res.data?.message) {
                exibirAlerta('Sucesso', 'Credenciais resetadas com sucesso', 'success');
                setOpen(false);

                if (reloadPessoa) {
                    await reloadPessoa();
                }
            }
        } catch (error) {
            exibirAlerta('Ops', 'Erro ao resetar credenciais', 'error');
        } finally {
            handleCloseDialog();
        }
    }

    return (
        <Dialog open={open}>
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                pb: 1
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Warning sx={{ color: '#FF9800', fontSize: 28 }} />
                    <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
                        Resetar Credenciais
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ pt: 2 }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2.5
                }}>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                        Esta ação irá <strong>redefinir a Bioface e a senha</strong> para
                        os padrões de primeiro acesso.
                    </Typography>

                    <Box sx={{
                        borderLeft: '4px solid #1D4F37',
                        p: 2,
                        borderRadius: 1
                    }}>
                        <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                            <Info sx={{ color: 'primary.main', fontSize: 20 }} />
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                Importante:
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ color: 'primary.main', lineHeight: 1.6 }}>
                            Após o reset, será necessário que o colaborador cadastre
                            uma nova senha e uma nova Bioface no próximo acesso ao sistema.
                        </Typography>
                    </Box>

                    <Typography variant="body2" color="text.secondary">
                        Deseja continuar com o reset das credenciais?
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                    Cancelar
                </Button>

                <Button variant="contained" onClick={handleResetCredentials}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}